<template>
    <section>
        <b-row>
            <b-col md="12">
                <b-alert
                    :show="dismissCountDown"
                    :variant="responseStatus"
                    fade
                    dismissible
                    @dismiss-count-down="countDownChanged"
                >
                    <div class="alert-body">
                        <feather-icon
                            icon="InfoIcon"
                        ></feather-icon>
                        {{ responseMessage }}
                    </div>
                </b-alert>
            </b-col>
        </b-row>
        <b-row
            v-if="hasApiKey && extendable"
        >
            <b-col
                md="12"
            >
                <ExtendableInfo
                    :availablePeriod="availablePeriod"
                    @alert:message="alertMessage"
                ></ExtendableInfo>
            </b-col>
        </b-row>
        <b-row>
            <b-col
                lg="12"
                xl="6"
            >
                <ApiStatusCard
                    v-model="showKey"
                    :extendablePeriod="EXTENDABLE_PERIOD"
                    :availablePeriod="availablePeriod"
                    :startDate="startDate"
                    :endDate="endDate"
                    @api:fetchUsages="apiFetchUsageData"
                    @alert:message="alertMessage"
                >
                </ApiStatusCard>
            </b-col>
            <b-col
                v-if="latestMonthUsage.length"
                lg="12"
                xl="6"
            >
                <b-overlay
                    :show="status.usageChartLatestMonth === 'loading'"
                >
                    <UsageChartLatestMonth
                        :chartData="latestMonthUsage"
                        :themeColors="themeColors"
                        @api:fetchDailyUsage="apiFetchDailyUsage"
                    />
                </b-overlay>
            </b-col>
        </b-row>
        <b-row
            v-if="latestMonthUsage.length"
        >
            <b-col
                lg="12"
                xl="12"
            >
                <b-overlay
                    :show="status.usageChartDaily === 'loading'"
                >
                    <UsageChartDaily
                        :theme="theme"
                        :chartData="dailyUsage"
                        :themeColors="themeColors"
                    />
                </b-overlay>
            </b-col>
        </b-row>
    </section>
</template>

<script>
import { getCurrentInstance, toRefs, inject, computed, ref } from '@vue/composition-api'
import ExtendableInfo from './_components/ExtendableInfo.vue'
import ApiStatusCard from './_components/ApiStatusCard.vue'
import UsageChartDaily from './_components/UsageChartDaily'
import UsageChartLatestMonth from './_components/UsageChartLatestMonth'
import moment from 'moment'
export default {
    name: 'OpenApiModule',
    components: {
        ExtendableInfo,
        ApiStatusCard,
        UsageChartDaily,
        UsageChartLatestMonth
    },
    props: {
        userIdx: {
            type: Number
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const EXTENDABLE_PERIOD = 30
        const store = vm.$store
        const STORE_KEY = '$_open_api'
        const { userIdx } = toRefs(props)
        const themeColors = inject('themeColors')
        const theme = inject('theme')
        const showKey = ref(false)
        const responseMessage = ref(null)
        const responseStatus = ref('')
        const dismissSecs = 5
        const dismissCountDown = ref(0)
        const latestMonthUsage = computed(() => store.getters[`${STORE_KEY}/latestMonthUsage`])
        const dailyUsage = computed(() => store.getters[`${STORE_KEY}/dailyUsage`])
        const hasApiKey = computed(() => store.getters[`${STORE_KEY}/hasApiKey`])
        const startDate = computed(() => store.getters[`${STORE_KEY}/startDate`])
        const endDate = computed(() => store.getters[`${STORE_KEY}/endDate`])
        const status = computed(() => store.getters[`${STORE_KEY}/status`])
        const extendable = computed(() => availablePeriod.value <= EXTENDABLE_PERIOD)
        const availablePeriod = computed(() => {
            const date = new Date().toISOString().substring(0, 10)
            const diffDays = moment(endDate.value).diff(moment(date), 'day')
            return diffDays
        })
        const fetchOpenApiLatestMonthUsage = (userIdx) => store.dispatch(`${STORE_KEY}/fetchOpenApiLatestMonthUsage`, { userIdx })
        const fetchOpenApiDailyUsage = (userIdx, month) => store.dispatch(`${STORE_KEY}/fetchOpenApiDailyUsage`, { userIdx, month })
        const apiFetchDailyUsage = ({ month }) => {
            fetchOpenApiDailyUsage(userIdx.value, month)
        }
        const apiFetchUsageData = () => {
            fetchOpenApiLatestMonthUsage(userIdx.value).then(() => {
                if (latestMonthUsage.value.length) {
                    fetchOpenApiDailyUsage(userIdx.value, latestMonthUsage.value[latestMonthUsage.value.length - 1].month)
                }
            })
        }
        const countDownChanged = (countDown) => {
            dismissCountDown.value = countDown
        }
        const alertMessage = ({ status, message }) => {
            dismissCountDown.value = dismissSecs
            responseStatus.value = status
            responseMessage.value = message
        }
        apiFetchUsageData()
        return {
            EXTENDABLE_PERIOD,
            theme,
            themeColors,
            latestMonthUsage,
            showKey,
            dailyUsage,
            hasApiKey,
            dismissCountDown,
            responseStatus,
            responseMessage,
            startDate,
            endDate,
            status,
            availablePeriod,
            extendable,
            apiFetchDailyUsage,
            apiFetchUsageData,
            alertMessage,
            countDownChanged
        }
    }
}
</script>

<style>

</style>
